import { IExternalLinkModel } from '@api/models';
import { removeUserFromExternalLink } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface RemoveUserFromExternalLinkOptions {
    clientId: string;
    externalLink: IExternalLinkModel;
}

const useRemoveUserFromExternalLinkForm = (options: RemoveUserFromExternalLinkOptions) => {
    const { externalLink, clientId } = options;

    const removeUserFromExternalLinkMutation = useMutation((userId: string) =>
        removeUserFromExternalLink(clientId, externalLink._id, userId)
    );

    const submit = async (value: string) => {
        await removeUserFromExternalLinkMutation.mutateAsync(value);
    };

    return {
        isLoading: removeUserFromExternalLinkMutation.isLoading,
        submit,
    };
};

export default useRemoveUserFromExternalLinkForm;
